import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { dashboardWithModal } from 'Consts/clientUris';
import { navigateTo } from 'Helpers/Redirect';
import { useHistory } from 'react-router-dom';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import Content from './Content';

export default function Scheduler({ className, resource }) {
  const history = useHistory();

  const canScheduledMeeting = hasRelationship(
    resource,
    fr.relationships.scheduleMeeting.name,
  );

  function scheduleMeeting() {
    if (canScheduledMeeting) {
      navigateTo(
        dashboardWithModal('clientSchedulerModal', {
          link: resource
            .relationship(fr.relationships.scheduleMeeting.name)
            .link('related')
            .url(),
        }),
      );
    }
  }

  function gotoDashboard() {
    history.push('/');
  }

  return (
    <>
      <WizardStepWrapperTemplate
        className={className}
        layout={Content}
        metaOverrideSet={BaseWizardStepOverride}
        LayoutProps={{ resource }}
        resource={resource}
        primaryActionLabel={canScheduledMeeting ? 'Schedule Next Meeting' : 'Go to the dashboard'}
        onNext={canScheduledMeeting ? scheduleMeeting : gotoDashboard}
      />
    </>
  );
}
